<div class="sm:absolute sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent"
     *ngIf="!showList else showDestination" [@zoomOut]="!showList" [@zoomIn]="showList && showDestination">

    <!-- Header -->
    <div
        class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8 border-b">
        <!-- Title -->
        <div
            class="text-4xl font-extrabold tracking-tight">Layouts
        </div>
        <!-- Actions -->
        <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
            <!-- Skins -->
            <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full lg:min-w-64 pr-1"
                            *ngIf="!displayAddElement"
                            [subscriptSizing]="'dynamic'">
                <mat-select placeholder="All" [formControl]="SkinSearchInputControl" (selectionChange)="searchElements(null)">
                    <ng-container *ngFor="let cmp of skinList">
                        <mat-option [value]="cmp.id_airline">
                            {{ cmp.ds_airline }}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
            <!-- Search by Name -->
            <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full lg:min-w-64 pr-1"
                            *ngIf="!displayAddElement"
                            [subscriptSizing]="'dynamic'">
                <mat-icon
                    class="icon-size-5"
                    matPrefix
                    [svgIcon]="'heroicons_solid:magnifying-glass'"></mat-icon>
                <input
                    matInput
                    (keyup)="onKeyup()"
                    [formControl]="nameSearchInputControl"
                    [autocomplete]="'off'"
                    [placeholder]="'Search by Name'">
            </mat-form-field>
            <!-- Add Destination button -->
<!--            <button-->
<!--                *ngIf="!displayAddElement && !reviewMode"-->
<!--                class="ml-4"-->
<!--                mat-stroked-button-->
<!--                [color]="'primary'"-->
<!--                (click)="displayAddElement = !displayAddElement">-->
<!--                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>-->
<!--                <span class="ml-2 mr-1">Add</span>-->
<!--            </button>-->
        </div>
    </div>

    <!-- Main -->
    <div class="flex flex-auto overflow-hidden">

        <!-- Products list -->
        <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto"
             *ngIf="!displayAddElement">
            <div class="grid">
                <!-- Header -->
                <div
                    class="layout-grid z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black">
                    <div class="hidden lg:block">Layout Type</div>
                    <div class="hidden lg:block">Layout Name</div>
                    <div class="hidden lg:block">Subscription</div>
                    <div class="hidden lg:block">Actions</div>
                </div>
                <!-- Rows -->
                <ng-container *ngIf="tableElements?.length > 0; else noElements">
                    <ng-container *ngFor="let element of tableElements">
                        <div
                            class="layout-grid grid items-center gap-4 py-3 px-6 md:px-8 border-b">

                            <!-- ID -->
                            <div class="truncate hidden md:block">
                                {{ element.ds_destinationtype }}
                            </div>

                            <!-- ID -->
                            <div class="truncate">
                                {{ element.ds_displaylayout }}
                            </div>

                            <!-- ID -->
                            <div class="truncate">
                                {{ element.ds_subscriptionrights }}
                            </div>

                            <!-- Details button -->
<!--                                [disabled]="element.en_state === 6"-->
                            <button
                                class="min-w-10 min-h-7 h-7 px-2 leading-6"
                                mat-stroked-button
                                color="primary"
                                (click)="switchToDestination(element.id_destinationtypelayout)">
                                <mat-icon
                                    class="icon-size-5"
                                    [svgIcon]="'heroicons_outline:cog-6-tooth'"></mat-icon>
                            </button>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-template #noElements>
                    <div class="p-8 sm:p-16 border-t text-4xl font-semibold tracking-tight text-center">{{
                            loadingMessage
                        }}
                        <ngx-spinner
                            bdColor="rgba(51,51,51,0)"
                            color="#fff"
                            size="medium"
                            type="ball-clip-rotate-multiple">
                            <p style="font-size: 20px; color: white">Loading...</p></ngx-spinner>
                    </div>
                </ng-template>
            </div>
<!--            <mat-paginator-->
<!--                class="sm:absolute sm:inset-x-0 sm:bottom-0 border-b sm:border-t sm:border-b-0 z-10 bg-gray-50 dark:bg-transparent"-->
<!--                (page)="searchElements('paginator')"-->
<!--                [ngClass]="{'pointer-events-none': showList}"-->
<!--                [length]="20"-->
<!--                [pageIndex]="0"-->
<!--                [pageSize]="20"-->
<!--                [pageSizeOptions]="[5, 10, 20, 100]"-->
<!--                [showFirstLastButtons]="true"></mat-paginator>-->
        </div>

        <div class="flex justify-center items-center w-full px-4 mb-20" *ngIf="displayAddElement"
             [@zoomIn]="displayAddElement">
            <div class="flex flex-col flex-auto w-full max-w-xl">
                <fuse-card
                    class="mt-8 p-6 pb-10 sm:p-10 sm:pb-7 rounded-2xl bg-card"
                    [flippable]="true"
                    [face]="'front'"
                    #flippableCard01="fuseCard">
                    <ng-container fuseCardFront>
                        <!--Alert-->
                        <fuse-alert
                            class="mb-8"
                            *ngIf="alert"
                            [type]="alert.type"
                            [showIcon]="false">
                            {{ alert.message }}
                        </fuse-alert>
                        <form
                            class="space-y-3"
                            (ngSubmit)="createDestination($event)"
                            [formGroup]="newElementForm">
                            <div class="mb-6">
                                <div class="text-2xl font-bold tracking-tight">Add New Layout
                                </div>
                            </div>
                            <!-- Name -->
                            <mat-form-field class="w-full">
                                <input
                                    maxlength="150"
                                    matInput
                                    [formControlName]="'ds_name'"
                                    [required]="true">
                                <mat-label>Name</mat-label>
                                <mat-error *ngIf="newElementForm.get('ds_name').hasError('required')">
                                    Required
                                </mat-error>
                            </mat-form-field>
                            <!-- Actions -->
                            <div class="flex items-center justify-end pb-4">
                                <button
                                    class="text-red-600"
                                    mat-stroked-button
                                    (click)="displayAddElement = !displayAddElement"
                                    [color]="'accent'">
                                    Cancel
                                </button>
                                <button
                                    class="ml-2"
                                    type="submit"
                                    mat-stroked-button
                                    [color]="'primary'">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </ng-container>

                </fuse-card>
            </div>
        </div>

    </div>

</div>

<ng-template #showDestination>
    <layouts-management (commandEvent)="handleCommand($event)" class="max-w-full overflow-hidden" [destination_ID]="destination_ID"></layouts-management>
</ng-template>
